/**
 * The DOM attribute feedback mode's own chrome uses to opt out of being
 * picked.
 *
 * It lives here rather than in `element-picker.tsx`, which defines the
 * behaviour, because five modules need only the string: the banner, the
 * header controls, the session recorder, the pin overlay and the picker
 * itself. Importing it from the picker pulled that module — a portal, a
 * keyboard-shortcut hook and a `'use server'` analytics import — into the
 * graph of every one of them for 26 characters.
 *
 * One definition is the point. A second spelling of the literal somewhere
 * else would be a string that looks right and opts nothing out, and the
 * failure is silent: the picker would anchor a viewer's feedback to the
 * banner or to somebody else's pin.
 */
export const FEEDBACK_MODE_EXEMPT_ATTRIBUTE = 'data-feedback-mode-exempt'
